<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] Page Popup" />

    <sui-page-contents>
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <button
            type="button"
            class="comm_btn_border_Prime"
            @click="onClickOpenPagePopup"
          >
            Open Page Popup
          </button>
          <button
            type="button"
            class="comm_btn_border_Prime"
            @click="onClickOpenComponentPopup"
          >
            Open Component Popup
          </button>
          </button>
          <button
            type="button"
            class="comm_btn_border_Prime"
            @click="onClickOpenWindowPopup"
          >
            Open Window Popup
          </button>
        </div>
        <div class="btn_wrapR" />
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>

import componentPopup from './componentPopup';

export default {
  name: 'CompGuidePagePopup',
  data() {
    return {
      popupWindow: null,
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    if (this.popupWindow) {
      this.popupWindow.onunload = null;
    }
  },
  destroyed() {},
  methods: {
    onClosePagePopup() {
      console.log('pagePopup.onClosePagePopup() was called.');

    },

    onClickOpenComponentPopup() {
      utils.openLayerPopup(componentPopup,
        this.onClosePagePopup,
        {
          pageInitialData: {},
          size: 'xlg',
          title: '컴포넌트 팝업',
          width: '400px',
        }
      );
    },

    onClickOpenPagePopup() {
      console.log('pagePopup.onClickOpenPagePopup() was called.');

      /**
       * 페이지 팝업
       *
       * @param {String} pageId 페이지아이디
       * @param {Function} closeCallback 닫기 버튼에 대한 콜백함수.
       * @param {Object} options
       * @param {String} options.size sm, md, lg, xlg 이 네 값 중에 하나만 유효함.
       * @param {String} options.pageInitialData
       */
      utils.openLayerPopup('PGE_CMZ_00001',
        this.onClosePagePopup,
        {
          pageInitialData: {},
          size: 'xlg',
        }
      );      
    },
    onClickOpenWindowPopup() {
      this.popupWindow = utils.openWindowPopup('PGE_CMZ_00001');
      this.popupWindow.addEventListener('beforeunload', this.onChildWindowLoad);
      // this.popupWindow.onload = this.onChildWindowLoad;
    },
    onChildWindowLoad() {
      this.popupWindow.onunload = this.onChildWindowUnload; // 컴포넌트가 destroy된 이후에도 호출될수 있으므로, beforeDestroy에서 null 처리
    },
    onChildWindowUnload() {
      this.popupWindow = null;
      utils.messageBox('information', 'child window가 unload 되었습니다');
      // refresh 처리
    },
  },
};
</script>

<style scoped>
</style>
